export default __webpack_public_path__ + "static/media/download.1087f9bd.svg";